export const courses = [
  {
    id: 'safe-driving',
    title: 'Complete Safe Driving Course',
    description: 'Master the fundamentals of safe driving and defensive driving techniques.',
    duration: '8 weeks',
    level: 'Beginner to Advanced',
    progress: 0,
    image: '/images/safe-driving.jpg',
    modules: [
      {
        id: 'module-1',
        title: 'Fundamentals of Safe Driving',
        lessons: [
          {
            id: 'lesson-1-1',
            title: 'Introduction to Safe Driving',
            topics: [
              {
                id: 'topic-1-1-1',
                title: 'Understanding Road Safety',
                contentId: 'content-1-1-1'
              },
              {
                id: 'topic-1-1-2',
                title: 'Vehicle Safety Checks',
                contentId: 'content-1-1-2'
              }
            ]
          },
          {
            id: 'lesson-1-2',
            title: 'Basic Vehicle Control',
            topics: [
              {
                id: 'topic-1-2-1',
                title: 'Steering and Handling',
                contentId: 'content-1-2-1'
              }
            ]
          }
        ]
      },
      {
        id: 'module-2',
        title: 'Advanced Driving Techniques',
        lessons: [
          {
            id: 'lesson-2-1',
            title: 'Defensive Driving',
            topics: [
              {
                id: 'topic-2-1-1',
                title: 'Situational Awareness',
                contentId: 'content-2-1-1'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'defensive-driving',
    title: 'Advanced Defensive Driving',
    description: 'Learn advanced techniques for anticipating and avoiding potential hazards.',
    duration: '6 weeks',
    level: 'Intermediate',
    progress: 0,
    image: '/images/defensive-driving.jpg',
    modules: [
      {
        id: 'module-1',
        title: 'Advanced Hazard Recognition',
        lessons: [
          {
            id: 'lesson-1-1',
            title: 'Complex Traffic Scenarios',
            topics: [
              {
                id: 'topic-1-1-1',
                title: 'Urban Driving Challenges',
                contentId: 'content-1-1-1'
              }
            ]
          }
        ]
      }
    ]
  }
];

// Mock content data (in a real app, this would come from an API)
export const contentData = {
  'content-1-1-1': {
    text: 'Road safety is a critical aspect of driving that encompasses various factors...',
    sections: [
      {
        title: 'Key Safety Principles',
        content: 'Understanding and following key safety principles is essential...'
      },
      {
        title: 'Common Road Hazards',
        content: 'Identifying and responding to common road hazards...'
      }
    ]
  },
  'content-1-1-2': {
    text: 'Regular vehicle safety checks are crucial for preventing accidents...',
    sections: [
      {
        title: 'Pre-Drive Inspection',
        content: 'Essential checks to perform before starting your journey...'
      },
      {
        title: 'Maintenance Schedule',
        content: 'Understanding your vehicle\'s maintenance requirements...'
      }
    ]
  },
  'content-1-2-1': {
    text: 'Proper steering and handling techniques are fundamental to safe driving...',
    sections: [
      {
        title: 'Steering Techniques',
        content: 'Different steering methods and when to use them...'
      },
      {
        title: 'Vehicle Balance',
        content: 'Maintaining proper vehicle balance during various maneuvers...'
      }
    ]
  },
  'content-2-1-1': {
    text: 'Developing and maintaining situational awareness is crucial for defensive driving...',
    sections: [
      {
        title: 'Scanning Techniques',
        content: 'Effective scanning methods to identify potential hazards...'
      },
      {
        title: 'Risk Assessment',
        content: 'How to assess and respond to various driving situations...'
      }
    ]
  }
};

export const getCourseById = (courseId) => {
  return courses.find(course => course.id === courseId);
};

export const getModuleById = (courseId, moduleId) => {
  const course = getCourseById(courseId);
  return course?.modules.find(module => module.id === moduleId);
};

export const getLessonById = (courseId, moduleId, lessonId) => {
  const module = getModuleById(courseId, moduleId);
  return module?.lessons.find(lesson => lesson.id === lessonId);
};

export const getTopicById = (courseId, moduleId, lessonId, topicId) => {
  const lesson = getLessonById(courseId, moduleId, lessonId);
  return lesson?.topics.find(topic => topic.id === topicId);
};

export const getContentById = (contentId) => {
  return contentData[contentId];
}; 